/**
 * 求字符串数组各元素字符数（.length）之和。
 * null/undefined/非字符串按 0 计；中文算 1。
 * @param {Array<string|null|undefined>} values
 * @returns {number}
 */
export function sumLengths(values) {
  if (!Array.isArray(values)) return 0
  return values.reduce((sum, v) => sum + (typeof v === 'string' ? v.length : 0), 0)
}
